import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function info({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="black"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      className={className}
    >
      <path
        stroke="none"
        fillRule="evenodd"
        d="M12 4a8 8 0 100 16 8 8 0 000-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z"
        clipRule="evenodd"
      />
      <path
        stroke="none"
        d="M12 7a1 1 0 100 2 1 1 0 000-2zM13 12a1 1 0 10-2 0v4a1 1 0 102 0v-4z"
      />
    </svg>
  );
}

export default info;
